var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F7801A",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.1667H13.4993C13.1457 14.1667 12.8066 14.3072 12.5565 14.5573C12.3065 14.8073 12.166 15.1465 12.166 15.5001V21.5001C12.166 21.8537 12.3065 22.1928 12.5565 22.4429C12.8066 22.6929 13.1457 22.8334 13.4993 22.8334H19.4993C19.853 22.8334 20.1921 22.6929 20.4422 22.4429C20.6922 22.1928 20.8327 21.8537 20.8327 21.5001V20.8334",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 12.8334L22.1667 14.8334M23.09 13.8901C23.3526 13.6275 23.5001 13.2714 23.5001 12.9001C23.5001 12.5287 23.3526 12.1726 23.09 11.9101C22.8274 11.6475 22.4713 11.5 22.1 11.5C21.7287 11.5 21.3726 11.6475 21.11 11.9101L15.5 17.5001V19.5001H17.5L23.09 13.8901Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8689deab7caf842fce98a25342c4e47c.svg";
export { ForwardRef as ReactComponent };